import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HttpStatusCode } from "axios";
import clsx from "clsx";

import {
  IncommodityCategory,
  getIncommodityCategoryList,
} from "../../../services/centerServices";
import { useUserContext } from "../../../contexts/userContext";

import CommonPopup from "..";
import CommonButton from "../../Button";
import {
  ReportQuestionIcon,
  ReportWarningIcon,
  ToiletErrorIcon,
  WashstandErrorIcon,
} from "../../../pages/Services/ToiletEmpty";
import SimplePopup from "../Simple";

type Props = { popup: string; onClose: () => void };

export default function ReportEmptyToilet({ popup, onClose }: Props) {
  const navigate = useNavigate();
  const [user] = useUserContext();
  const [category, setCategory] = useState<IncommodityCategory[]>();
  const [simplePopup, setSimplePopup] = useState("");
  const categoryList = [
    { name: "변기가 막혔어요", icon: ToiletErrorIcon },
    { name: "세면대가 막혔어요", icon: WashstandErrorIcon },
    {
      name: "도와주세요",
      icon: ReportQuestionIcon,
      matchName: "기타(청소)",
    },
  ];

  const loadCategory = async () => {
    const res = await getIncommodityCategoryList({
      buildingId: user.buildingId as string,
      searchWord: "",
    });
    if (res.status === HttpStatusCode.Ok) {
      const newCategoryList: IncommodityCategory[] = [];
      Object.values(res.data).forEach((categoryList) =>
        newCategoryList.push(...categoryList)
      );
      setCategory(newCategoryList);
    }
  };

  useEffect(() => {
    if (user.isLoading === false && user.buildingId) {
      loadCategory();
    }
  }, [user.isLoading, user.buildingId]);

  return (
    <CommonPopup
      isOpen={popup === "reportEmptyToilet"}
      onClose={onClose}
      title="불편신고 안내"
      unUseHorizonRule
      padding={0}
    >
      <div className="p-5 pt-0">
        <div className="flex flex-col gap-2.5">
          <div className="pt-2.5 pb-8 flex flex-col gap-2.5 items-center">
            <ReportWarningIcon />
            <div className="text-md font-normal leading-[26px] whitespace-pre-line text-center text-brand-neutral-60">
              {
                "이용에 불편을 겪으셨나요?\n화장실과 관련된 불편사항이 있을 경우\n아래 메뉴를 선택해주세요"
              }
            </div>
          </div>
          <div className="grid grid-cols-3 gap-2.5">
            {categoryList.map((currentCategoryItem, index) => {
              const currentCategory = category?.find(
                (c) =>
                  c.serviceName ===
                  (currentCategoryItem.matchName ?? currentCategoryItem.name)
              );

              return (
                <CommonButton
                  key={index}
                  variant="tertiary"
                  onClick={() => {
                    if (!currentCategory) {
                      setSimplePopup("notSupportService");
                      return;
                    }
                    navigate("/report", {
                      state: {
                        buildingId: user.buildingId,
                        buildingName: user.buildingName,
                        buildingFloorId: user.buildingFloorId,
                        buildingFloorName: user.buildingFloorName,
                        buildingSpaceId: user.buildingSpaceId,
                        buildingSpaceName: user.buildingSpaceName,
                        serviceTemplateId: currentCategory?.serviceTemplateId,
                        parentUrl: "/service/toilet-empty",
                        parentState: { popup: "reportEmptyToilet" },
                      },
                    });
                  }}
                  className={clsx([
                    "whitespace-pre-line flex flex-col gap-2.5 items-center text-center px-1 py-[11px]",
                    {
                      "opacity-60": !currentCategory,
                    },
                  ])}
                >
                  {currentCategoryItem?.icon()}
                  <div className="text-sm font-medium leading-[17px] text-black">
                    {currentCategoryItem?.name.replace(" ", "\n")}
                  </div>
                </CommonButton>
              );
            })}
          </div>
        </div>
      </div>

      <SimplePopup
        isOpen={simplePopup === "notSupportService"}
        onClose={() => setSimplePopup("")}
        message="건물이 지원하지 않는 서비스예요."
      />
    </CommonPopup>
  );
}
